









































import newDocument from './documents/forms/newDocument.vue';
import company from '@/store/types/company';
import document from '@/store/types/document';
import { ImageUpload } from '@/store/interfaces/uploadimage';
import { mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'CompanyDocuments',
  components: { newDocument, },
  props: {
    isSaveSuccess: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      getlistDocumentKind: `documentModule/${document.getters.GET_DOCUMENT_KIND}`,
      getNewCompanyParams: `companyModule/${company.getters.GET_NEW_COMPANY_PARAMS}`,
    }),
  },
  methods: {
    saveCompany(): void {
      let documents: ImageUpload[] = [];
      documents = (
        this.$refs.documentCompany as InstanceType<typeof newDocument>
      ).$data.documents;

      const documentContact = this.$refs.documentContact as InstanceType<
        typeof newDocument
      >;
      if (documentContact) {
        documents = [...documents, ...documentContact.$data.documents];
      }
      this.$emit('saveCompany', documents);
    },
    cancel(): void {
      this.$emit('cancel', true);
    },
  },
});
